module.exports = __webpack_public_path__ + "11102293.svg";